import { Controller } from "@hotwired/stimulus"

// Тоггл «Показать полностью / Скрыть» для длинных текстов.
export default class extends Controller {
  static targets = ["body", "label"]
  static values = { expanded: Boolean }

  toggle() {
    this.expandedValue = !this.expandedValue
  }

  expandedValueChanged() {
    this.element.classList.toggle("is-expanded", this.expandedValue)
    this.element.querySelectorAll("[aria-expanded]").forEach((el) => {
      el.setAttribute("aria-expanded", this.expandedValue ? "true" : "false")
    })
    if (this.hasLabelTarget) {
      this.labelTarget.textContent = this.expandedValue ? "Скрыть" : "Показать полностью"
    }
  }
}
